import { DeleteOutlined, DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Row, Typography } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { useState } from "react";
import { useDealer } from "../../../tools/api";
import { complexDigitToman } from "../../../tools/tools";

const { Paragraph, Text } = Typography;
function FormBulk({ bulk, setBulk, styles }) {
	const { convertDCFileToJson } = useDealer();
	const [fileList, setFileList] = useState([]);
	const [fileContent, setFileContent] = useState(null);
	const [fileName, setFileName] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	const handlePreview = (file) => {
		const reader = new FileReader();
		reader.onload = () => {
			setFileContent(reader.result);
		};
		reader.readAsText(file.originFileObj); // خواندن فایل متنی
	};

	const handleChange = (info) => {
		const files = info.fileList.slice(-1); // فقط آخرین فایل را نگه می‌دارد
		// setFileList(files);
		if (files.length > 0) {
			setFileName(files[0].name); // ذخیره نام فایل
			handlePreview(files[0]);
		} else {
			setFileContent(null);
			setFileName(null);
		}
	};

	const handleRemove = () => {
		setFileList([]);
		setFileContent(null);
		setFileName(null);
	};

	const uploadHandler = async () => {
		setIsLoading(true);
		const formData = new FormData();
		fileList.forEach((file) => {
			formData.append("file", file);
		});

		const response = await convertDCFileToJson(formData);
		if (response) {
			const bulks = response.map((item, key) => ({
				key: key,
				msisdn: item.msisdn,
				amount: complexDigitToman(item.amount),
				description: item.description,
				result: "در انتظار پردازش",
			}));
			const total = response.reduce((curr, i) => {
				return curr + i.amount;
			}, 0);
			console.log(total);
			setBulk((prev) => ({ ...prev, step: 2, List: bulks, calAmount: total }));
		}
		setIsLoading(false);
	};
	return (
		<Form
			//form={frmDCBulk}
			layout="vertical">
			<Row>
				<Col span={8}>
					<Form.Item label="ابتدا فایل نمونه را دانلود کرده سپس طبق فایل نمونه بارگذاری کنید">
						<Button className="btn-normal" icon={<DownloadOutlined />} size={"large"}>
							<a target="_blank" download href={process.env.REACT_APP_PATH + `/assets/sample/dc-sample.txt`}>
								دانلود فایل نمونه
							</a>
						</Button>
					</Form.Item>
					<Form.Item>
						<Card bodyStyle={{ padding: "20px" }}>
							{fileContent ? (
								<div onClick={handleRemove}>
									<Text strong>{fileName}</Text>
									<Paragraph
										style={{
											marginTop: 10,
											padding: 10,
											border: "1px dashed #f0f0f0",
											borderRadius: 4,
											backgroundColor: "#fafafa",
											textAlign: "left",
											maxHeight: 200,
											overflowY: "auto",
										}}>
										{fileContent}
									</Paragraph>
									<Button type="primary" danger icon={<DeleteOutlined />} style={{ marginTop: 10 }}>
										حذف فایل
									</Button>
								</div>
							) : (
								<Dragger
									fileList={fileList}
									beforeUpload={(file) => setFileList([file])} // جلوگیری از آپلود خودکار
									onChange={handleChange}
									accept=".txt" // فقط فایل‌های متنی
									style={{
										padding: "20px",
										borderRadius: 8,
										borderStyle: "dashed",
									}}>
									<p className="ant-upload-drag-icon">
										<UploadOutlined color="#ccc" style={{ color: "red" }} />
									</p>
									<p className="ant-upload-text">آپلود فایل </p>
									<p className="ant-upload-hint">فقط فایل txt</p>
								</Dragger>
							)}
						</Card>
					</Form.Item>
					{fileList.length > 0 && (
						<Form.Item>
							<Button disabled={isLoading} onClick={uploadHandler} className="btn-normal btn-aptel">
								آپلود فایل
							</Button>
						</Form.Item>
					)}

					{/* <div className={styles.row_input}>
                    <div className={styles.uploadFile}>
                        <Upload {...props}>
                            <Button icon={<UploadOutlined />}>انتخاب فایل</Button>
                        </Upload>
                    </div>
                    <div>
                        <Button
                            className="btn-normal btn-aptel"
                            onClick={handleUpload}
                            disabled={fileList.length === 0}
                            style={{
                                marginTop: 16,
                            }}>
                            پردازش
                        </Button>
                    </div>
                </div>
            </Form.Item> */}
				</Col>
			</Row>
		</Form>
	);
}

export default FormBulk;
